import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBeam = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 5.5V8.36426L4.5 13.877L2 12.499V9.77539L13.5 4.11035L16 5.5ZM3 10.2002L4.5 10.9766L15 5.88965L13.5 5.10938L3 10.2002Z",
		fill: "black"
	})
});
export default SvgBeam;
